import { memo } from 'react';
import {
  Login,
  LoginContent,
  LogoContainer,
  SignInButton,
  ResetPasswordButton,
  LoginButton,
  Powered,
  ButtonContainer,
} from '../../index.styled';
import Logo from '../../../assets/images/ChurchLogo.svg';
import Link from 'next/link';
import {
  BackButton,
  BackButtonContent,
  Form,
  TextField,
  TextFieldWrapper,
} from '../../signup/index.styled';
import BackButtonSvg from '../../../assets/images/BackButton.svg';
import { pageType } from '../../../constans/signin';
import { alertType } from '../../../constans/alert';

const LoginLayout = ({
  authData,
  handleInputChange,
  onLogin,
  handleErrorData,
  handleKeyPress,
  handlePage,
  churchInfo,
}) => {
  return (
    <Login>
      <LoginContent>
        <LogoContainer>
          <img src={churchInfo.logo} />
        </LogoContainer>
        <Form>
          <BackButtonContent onClick={() => handlePage(pageType.signin)}>
            <BackButton>
              <BackButtonSvg />
            </BackButton>
            Sign In
          </BackButtonContent>
          <TextFieldWrapper>
            <TextField
              placeholder="Email"
              id="email"
              name="email"
              value={authData && authData.email}
              onKeyPress={handleKeyPress}
              onChange={handleInputChange}
            ></TextField>
            <TextField
              placeholder="Password"
              name="password"
              type="password"
              id="password"
              value={authData && authData?.password}
              onKeyPress={handleKeyPress}
              onChange={handleInputChange}
            ></TextField>
          </TextFieldWrapper>
          <ButtonContainer>
            <LoginButton
              color={'white'}
              onClick={() => {
                authData && !authData.email
                  ? handleErrorData(alertType.WARNING, 'Email field is empty')
                  : !authData?.password
                  ? handleErrorData(alertType.WARNING, 'Password filed is empty')
                  : onLogin();
              }}
            >
              Sign In
            </LoginButton>
          </ButtonContainer>
          <Link href="/signup">
            <SignInButton>
              Don't have an account? &ensp; <b>Sign up</b>
            </SignInButton>
          </Link>
          <Link href="/signin/reset_password">
            <ResetPasswordButton>Forgot your password?</ResetPasswordButton>
          </Link>
        </Form>
        <Powered>v1.1.1 (260) | © 2022 Togather</Powered>
      </LoginContent>
    </Login>
  );
};

export default memo(LoginLayout);
